/**
 * Reorder Fileflare download rows on the big bundles so customers start with
 * what they previewed. Fileflare only sorts A–Z / date / size.
 *
 * Two bundles are ranked:
 *   The Bundle 3           — product-page demo order (ug-bundle-3-demos.json),
 *                            presets / Ableton / Sylenth crates last.
 *   Ultimate Vocals Bundle — the ten dedicated vocal packs first (Wagathoni
 *                            leads as the newest), then the vocal selections
 *                            pulled from the genre packs.
 *
 * Runs on the digital-delivery page (.dda-orders). No-ops everywhere else.
 */
(function () {
  'use strict';

  var MIN_ASSETS = 40;

  // Same order as the Bundle 3 PDP demos. Longest needle wins so sequels
  // ("House Chords 2") and presets do not steal the sample-pack slot.
  // Ghetto Tech and Romanian Minimal House ship in the ZIP but have no demo.
  var BUNDLE_3_ORDER = [
    ['deep and jazz house', 'deep jazz house'],
    ['deep tech house', 'deep tech-house'],
    ['deep and jazz house 2', 'deep jazz house 2'],
    ['rave renaissance'],
    ['classic dub techno'],
    ['techno awakening'],
    ['modular electronica'],
    ['lo-fi soul', 'lo fi soul'],
    ['dungeon techno'],
    ['organic house'],
    ['danktronica'],
    ['organic techno'],
    ['house of chords'],
    ['chicago house'],
    ['deep grooves'],
    ['toneaffair', 'tone affair'],
    ['grime 2.0', 'grime 2'],
    ['real deep'],
    ['lo-fi house', 'lo fi house'],
    ['basement jams'],
    ['detroit electro'],
    ['liquid electronica'],
    ['deep techno excursions'],
    ['house chords'],
    ['techno stabs'],
    ['evolving arps'],
    ['analogue transmission'],
    ['noir electronique'],
    ['raw deep'],
    ['dub techno chords'],
    ['hypnotic techno'],
    ['cloudtronica'],
    ['lo-fi analogue sessions', 'lo fi analogue sessions'],
    ['trap soul'],
    ['techno machine'],
    ['minimal house and deep tech', 'minimal house & deep tech'],
    ['jacking tech-house', 'jackin tech-house', 'jackin tech house'],
    ['deep analogue tools'],
    ['ambient house visions'],
    ['deep vintage keys'],
    ['warehouse techno'],
    ['deep and dubby house', 'deep & dubby house'],
    ['melodic house and deep techno', 'melodic house & deep techno'],
    ['techno stabs 2'],
    ['strictly minimal'],
    ['deep melodic horizons'],
    ['purist techno'],
    ['chilltronica'],
    ['dirty south'],
    ['analogue and modular techno'],
    ['retro memories'],
    ['modular house'],
    ['deep dub techno'],
    ['dreamtronica'],
    ['techno drum trax 2', 'techno drum trax'],
    ['underground tech-house', 'underground tech house'],
    ['leftfield techno'],
    ['modular percussion'],
    ['house chords 2'],
    ['dub techno chords 2'],
    ['deep melodic house'],
    ['minimal house'],
    ['ghetto tech'],
    ['romanian minimal house'],
    ['deep tech-house presets', 'deep tech house presets'],
    ['analogue underground presets'],
    ['retro synths for ableton', 'retro synths'],
    ['future soul presets'],
    ['grime presets'],
    ['deep house presets'],
    ['classic massive chords'],
    ['classic uk garage presets'],
    ['detroit electro presets'],
    ['sylenth arps'],
    ['sylenth modular presets']
  ];

  // Ultimate Vocals Bundle: one ZIP per pack since it outgrew the 5 GB
  // Digital Downloads ceiling. Dedicated vocal packs first — that is what the
  // bundle is bought for — then the vocal selections from the genre packs,
  // which ship as "Vocals from <pack>".
  var UVB_ORDER = [
    ['wagathoni'],
    ['soulful house vocals'],
    ['classic house vocals'],
    ['classic house vocals 2'],
    ['tech house vocals'],
    ['techno vocals'],
    ['techno vocals 2'],
    ['disco vocals'],
    ['melodic house vocals'],
    ['lillie mccloud'],
    ['lo fi soul'],
    ['hip house'],
    ['liquid electronica'],
    ['classic euphoric trance'],
    ['emotive electronica'],
    ['juke and footwork'],
    ['trippy body techno'],
    ['lo fi deep house 2'],
    ['they call it acid'],
    ['basement techno sessions'],
    ['classic deep house 3'],
    ['cloudtronica'],
    ['mainroom tech house'],
    ['uk garage and bass'],
    ['classic jungle'],
    ['raw tech house'],
    ['uk bass and breaks'],
    ['strictly minimal'],
    ['trap soul and r and b haze', 'trap soul'],
    ['industrial techno'],
    ['chicago house'],
    ['dreamtronica'],
    ['tough tech house'],
    ['rave renaissance'],
    ['classic and jacking house'],
    ['psychedelic house'],
  ];

  var BUNDLES = [
    { re: /bundle\s*3/i, order: BUNDLE_3_ORDER, presetsLast: true,
      hint: 'Same order as the demos on the product page. Presets and Ableton / Sylenth crates are at the bottom.' },
    { re: /ultimate\s*vocals/i, order: UVB_ORDER, presetsLast: false,
      hint: 'Vocal packs first, then the vocal selections from each genre pack.' },
  ];

  // Any filename with these tokens is a preset/instrument crate, so bump it
  // below every sample pack even if it also matches a sample needle
  // (e.g. "Deep Tech-House Presets" vs "Deep Tech House").
  var PRESET_RE = /\b(preset|presets|ableton|massive chords|sylenth)\b/;

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9.]+/g, ' ')
      .replace(/\b(undrgrnd|sounds|wav|zip|loops)\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function rank(text, bundle) {
    var n = norm(text);
    var order = bundle.order;
    var best = { i: 1000, len: 0 };
    for (var i = 0; i < order.length; i++) {
      var needles = order[i];
      for (var j = 0; j < needles.length; j++) {
        var nd = norm(needles[j]);
        if (nd && n.indexOf(nd) !== -1 && nd.length > best.len) {
          best = { i: i, len: nd.length };
        }
      }
    }
    if (bundle.presetsLast && PRESET_RE.test(n)) return 800 + best.i;
    return best.i;
  }

  function assetLabel(el) {
    var name = el.querySelector('.dda-order__asset-filename');
    return ((name && name.textContent) || el.textContent || '').replace(/\s+/g, ' ');
  }

  function matchBundle(root) {
    var headers = root.querySelectorAll('.dda-order__item-name');
    for (var i = 0; i < headers.length; i++) {
      var text = headers[i].textContent || '';
      for (var b = 0; b < BUNDLES.length; b++) {
        if (BUNDLES[b].re.test(text)) return BUNDLES[b];
      }
    }
    // Fall back to Bundle 3 on asset count alone: it is the only product with
    // this many rows if the header markup ever changes shape.
    if (root.querySelectorAll('.dda-order__asset').length >= MIN_ASSETS) {
      return BUNDLES[0];
    }
    return null;
  }

  function sortList(container, bundle) {
    var items = Array.prototype.slice.call(container.querySelectorAll('.dda-order__asset'));
    if (items.length < 8) return false;
    var parent = items[0].parentNode;
    var keyed = items.map(function (el, idx) {
      return { el: el, r: rank(assetLabel(el), bundle), idx: idx };
    });
    keyed.sort(function (a, b) {
      if (a.r !== b.r) return a.r - b.r;
      return a.idx - b.idx;
    });
    keyed.forEach(function (row) { parent.appendChild(row.el); });
    addHintToParent(parent, keyed[0].el, bundle);
    return true;
  }

  function addHintToParent(parent, firstAsset, bundle) {
    if (parent.querySelector('.ug-download-start')) return;
    var hint = document.createElement('p');
    hint.className = 'ug-download-start';
    hint.textContent = bundle.hint;
    parent.insertBefore(hint, firstAsset);
  }

  function alreadyRanked(root, bundle) {
    if (!root.classList.contains('ug-download-ranked')) return false;
    var first = root.querySelector('.dda-order__asset');
    var count = root.querySelectorAll('.dda-order__asset').length;
    if (!first || count !== window.__ugFileflareAssetCount) return false;
    return rank(assetLabel(first), bundle) < 10;
  }

  function run(root) {
    if (!root) return;
    var bundle = matchBundle(root);
    if (!bundle) return;
    if (alreadyRanked(root, bundle)) return;
    var obs = window.__ugFileflareSortObs;
    if (obs) obs.disconnect();
    var lists = root.querySelectorAll('.dda-order__item-content');
    if (!lists.length) lists = [root];
    var any = false;
    for (var i = 0; i < lists.length; i++) {
      if (sortList(lists[i], bundle)) any = true;
    }
    if (any) {
      root.classList.add('ug-download-ranked');
      window.__ugFileflareAssetCount = root.querySelectorAll('.dda-order__asset').length;
    }
    if (obs) obs.observe(root, { childList: true, subtree: true });
  }

  function attach(root) {
    if (!window.__ugFileflareSortObs) {
      window.__ugFileflareSortObs = new MutationObserver(function () { run(root); });
    }
    run(root);
    window.__ugFileflareSortObs.observe(root, { childList: true, subtree: true });
  }

  function boot() {
    var root = document.querySelector('.dda-orders');
    if (root) {
      attach(root);
      return;
    }
    if (window.__ugFileflareSortDocObs) return;
    var docObs = new MutationObserver(function () {
      var found = document.querySelector('.dda-orders');
      if (!found) return;
      docObs.disconnect();
      window.__ugFileflareSortDocObs = null;
      attach(found);
    });
    window.__ugFileflareSortDocObs = docObs;
    docObs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
